export const HamburgerIcon = () => (
  <svg width={22} height={14} viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.556 1.54H21M6.556 7 21 7.003m-14.444 5.46L21 12.463M1.556 1.538h.01M1.557 7h.01m-.01 5.461h.01m.545-10.923a.547.547 0 0 1-.555.539A.547.547 0 0 1 1 1.538C1 1.241 1.249 1 1.556 1c.306 0 .555.241.555.538Zm0 5.462a.547.547 0 0 1-.555.538A.547.547 0 0 1 1 7c0-.297.249-.538.556-.538.306 0 .555.24.555.538Zm0 5.461a.547.547 0 0 1-.555.539.547.547 0 0 1-.556-.539c0-.297.249-.538.556-.538.306 0 .555.241.555.538Z"
      stroke="#333132"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
)
